import { Dispatch } from 'redux'

import { useThunkActions } from 'redux/actions/useThunkActions'
import * as ObjectSizeMapperApi from 'redux/api/internal/ObjectSizeMapper'
import { PostObjectSizeMappingBody } from 'types/GlobalNormalizedRent'
import { toggleSnackbarOpen } from 'redux/actions/Snackbar'
import { SnackbarMessage } from 'types/GlobalSnackbar'

import * as actions from './actions'

function tryGetObjectSizeMappings(customerId: string) {
  return (dispatch: Dispatch) => {
    dispatch(actions.getObjectSizeMappings())

    ObjectSizeMapperApi.getObjectSizeMappings(customerId)
      .then((response) => {
        dispatch(
          actions.getObjectSizeMappingsSuccess({
            customerId,
            mappings: response.data.data
          })
        )
      })
      .catch(() => {
        dispatch(actions.getObjectSizeMappingsFailed())
      })
  }
}

function tryCreateObjectSizeMapping(
  customerId: string,
  body: PostObjectSizeMappingBody
) {
  return (dispatch: Dispatch) => {
    dispatch(actions.createObjectSizeMapping())

    ObjectSizeMapperApi.createObjectSizeMapping(customerId, body)
      .then((response) => {
        dispatch(actions.createObjectSizeMappingSuccess(response.data.data))
        dispatch(toggleSnackbarOpen(SnackbarMessage.Success))
      })
      .catch(() => {
        dispatch(actions.createObjectSizeMappingFailed())
      })
  }
}

function tryDeleteObjectSizeMapping(customerId: string, mappingId: string) {
  return (dispatch: Dispatch) => {
    dispatch(actions.deleteObjectSizeMapping())

    ObjectSizeMapperApi.deleteObjectSizeMapping(customerId, mappingId)
      .then(() => {
        dispatch(
          actions.deleteObjectSizeMappingSuccess({ customerId, mappingId })
        )
        dispatch(toggleSnackbarOpen(SnackbarMessage.Success))
      })
      .catch(() => {
        dispatch(actions.deleteObjectSizeMappingFailed())
      })
  }
}

export const useObjectSizeMapperActions = () => {
  return {
    tryGetObjectSizeMappings: useThunkActions(tryGetObjectSizeMappings),
    tryCreateObjectSizeMapping: useThunkActions(tryCreateObjectSizeMapping),
    tryDeleteObjectSizeMapping: useThunkActions(tryDeleteObjectSizeMapping)
  }
}
